
  import { defineComponent, PropType } from 'vue';

  import ExportButtons from '@/common/components/redesigned/ExportButtons.vue';
  import SelectMultiComponentDashed from '@/common/components/SelectMultiComponentDashed.vue';

  import { TDashboardMainFilterWithOptionalYear } from '../../../types/dashboards';
  import DashboardsYearFilterBlock from '../DashboardsYearFilterBlock.vue';
  import { TSelectConfig } from './types';

  export { TSelectConfig } from './types';

  export default defineComponent({
    name: 'DashboardsCardFilterBlock',
    components: {
      SelectMultiComponentDashed,
      ExportButtons,
      DashboardsYearFilterBlock,
    },
    emits: {
      changeFilter: (value: TDashboardMainFilterWithOptionalYear) => value,
      downloadPDF: () => true,
      downloadPptx: () => true,
    },
    props: {
      filter: {
        type: Object as PropType<TDashboardMainFilterWithOptionalYear>,
        required: true,
      },
      selectConfig: {
        type: Object as PropType<TSelectConfig>,
        required: true,
      },
      isShowYearFilter: {
        type: Boolean,
        default: true,
      },
      isExportProgress: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      getBaseFilter(): TDashboardMainFilterWithOptionalYear {
        return {
          year: this.filter.year,
        };
      },
      getSelectFilterKey(): keyof TDashboardMainFilterWithOptionalYear {
        return this.selectConfig.filterKey;
      },
      getSelectFilterValue() {
        return this.filter[this.getSelectFilterKey];
      },
    },
    methods: {
      changeFilter(filter: TDashboardMainFilterWithOptionalYear) {
        this.$emit('changeFilter', { ...filter, [this.getSelectFilterKey]: this.getSelectFilterValue });
      },
      changeSelectFilter(value: number) {
        this.$router.replace({ params: { [this.getSelectFilterKey]: value.toString() } });
      },
      downloadPDF() {
        this.$emit('downloadPDF');
      },
      downloadPptx() {
        this.$emit('downloadPptx');
      },
    },
  });
